import {ReactNode, useContext} from 'react';
import {FormElementContext} from '../../form';

interface Props {
	className?: string;
	position?: 'left' | 'right' | 'top';
	children: ReactNode;
}

export function Label(props: Props): JSX.Element {
	const context = useContext(FormElementContext);
	const id = context?.ref?.id;
	return <div className={props.className}>
		<label htmlFor={id}>{props.children}</label>
	</div>;
}
